import { Color, Flex, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const HighlightedIconWrapper = styled(Flex)`
  width: 40px;
  min-width: 40px;
  height: 40px;
  margin-right: ${Spacing.S8};
  border-radius: 50%;
  background-color: ${Color.Grey100};
`
